import { PaymentProcessorEnum } from '@systemeio/types';
import { BadRequest, InternalError } from '@systemeio/util';
import { ManageSubscriptionsInterface } from 'modules/profile/manage-subscriptions/types/manage-subscriptions-interface';
import React, { useState } from 'react';
import { Button, Modal, toast } from 'shared/components';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getCancelSubscriptionApiHandler } from '../utils/get-cancel-subscription-api-handler';
interface CancelSubscriptionModalProps {
  opened: boolean;
  onClose: () => void;
  subscription: ManageSubscriptionsInterface;
  onUnsubscribe: (subscriptionItemId: number) => Promise<void>;
}
function CancelSubscriptionModal({
  opened,
  onClose,
  subscription,
  onUnsubscribe
}: CancelSubscriptionModalProps) {
  const {
    t
  } = useLocoTranslation();
  const [error, setError] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const cancelSubscriptionApiHandler = getCancelSubscriptionApiHandler(subscription.paymentProcessor, subscription.id, subscription.subscriptionItems?.[0]?.id || 0);
  const handleConfirm = async () => {
    try {
      setIsFetching(true);
      if (subscription.paymentProcessor === PaymentProcessorEnum.PaypalRest) {
        toast.info(t('dashboard.subscriptions.paypal_rest_cancel_in_progress'));
      }
      await cancelSubscriptionApiHandler();
      await onUnsubscribe(subscription.subscriptionItems?.[0]?.id || 0);
      setIsFetching(false);
      onClose();
      if (subscription.paymentProcessor !== PaymentProcessorEnum.PaypalRest) {
        toast.success(t('dashboard.subscriptions.unsubscribed'));
      }
    } catch (e) {
      setIsFetching(false);
      if (e instanceof BadRequest) {
        if (e.errors.common) {
          setError(e.errors.common.join(''));
        }
      } else if (e instanceof InternalError) {
        setError(t('core.error.internal_error_message'));
      } else {
        toast.error(t('global.error'));
      }
    }
  };
  return <>
      <Modal opened={opened} onClose={onClose} title={t('confirmation_modal.default_title')} isFetching={isFetching}>
        <form className="desktop:gap-10 flex flex-col gap-6">
          <div className="flex justify-center">
            <p>{t('dashboard.settings.manage_subscriptions.unsubscribe_confirmation')}</p>
          </div>
          <div className="tablet:[&>*]:flex-none tablet:[&>*]:w-auto flex justify-end gap-3 [&>*]:flex-1">
            <Button onClick={(e_0: React.MouseEvent<HTMLButtonElement>) => {
            e_0.preventDefault();
            onClose();
          }} disabled={isFetching} variant="secondary" size="md">
              {t('confirmation_modal.cancel')}
            </Button>
            <Button onClick={async (e_1: React.MouseEvent<HTMLButtonElement>) => {
            e_1.preventDefault();
            await handleConfirm();
          }} type="submit" isLoading={isFetching} variant="primary" size="md">
              {t('confirmation_modal.confirm')}
            </Button>
          </div>
          <FieldErrorAndDescription error={error} errorClassName={'text-center'} />
        </form>
      </Modal>
    </>;
}
export default CancelSubscriptionModal;